export default __webpack_public_path__ + "static/media/shield5.5a81769c.svg";